import { render } from "./DialogAddCompany.vue?vue&type=template&id=1494acf3&scoped=true&ts=true"
import script from "./DialogAddCompany.vue?vue&type=script&lang=ts"
export * from "./DialogAddCompany.vue?vue&type=script&lang=ts"

import "./DialogAddCompany.vue?vue&type=style&index=0&id=1494acf3&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1494acf3"]])

export default __exports__